import cacheSmartTimeExtendedPropertyAction from '../actions/cacheSmartTimeExtendedPropertyAction';
import { ClientItem, SmartTimeExtendedProperty } from 'owa-mail-store';
import { mutator } from 'satcheljs';

export default mutator(
    cacheSmartTimeExtendedPropertyAction,
    function cacheSmartTimeExtendedProperty(actionMessage: {
        item: ClientItem;
        validPropertyExists: boolean;
        smartTimesExtendedProp?: SmartTimeExtendedProperty;
    }) {
        // Null/false for these properties means we didn't find a valid property on the item.
        // We assign these values so that we don't bother fetching the stamped property again.
        let smartTimeSuggestedProperty: SmartTimeExtendedProperty = {
            beginingOfTimeRange: null,
            endOfTimeRange: null,
            duration: null,
            entityId: null,
            hasIntent: false,
            confidenceScore: 0,
            scheduler: '',
            rawConfidenceScores: null,
        };

        const { item, validPropertyExists, smartTimesExtendedProp } = actionMessage;

        if (validPropertyExists && smartTimesExtendedProp) {
            smartTimeSuggestedProperty = {
                ...smartTimesExtendedProp,
                hasIntent: true,
            };
        }

        item.SmartTimeExtendedProperty = smartTimeSuggestedProperty;
    }
);
